import { Component, Vue } from 'vue-property-decorator';
import { TenantsHeader, TenantsList, TenantsFilter } from '@/components/tenants';
import TenantsStore from '@/store/modules/TenantsStoreModule';
import { AppStoreModule, TenantsStoreModule } from '@/store';
import IAdminService from '@/services/http/interfaces/IAdminService';
import AppStore from '@/store/modules/AppStoreModule';

@Component({
  components: {
    TenantsHeader,
    TenantsList,
    TenantsFilter,
  },
})
export default class Tenants extends Vue {

  tenants$: TenantsStore = TenantsStoreModule;
  app$: AppStore = AppStoreModule;

  private adminService?: IAdminService;

  get isLoading(): boolean {
    return this.app$.isLoading;
  }

  mounted() {
    this.initServices();
    this.tenants$.getTenants(this.adminService!);
  }

  initServices(): void {
    this.adminService = this.$factory.createAdminService();
  }

  filterChange(filter: string): void {
    this.tenants$.setFilter(filter);
  }

  pageChange(page: number): void {
    this.tenants$.setCurrentPage(page);
  }

  tenantClicked(tenantId: string): void {
    this.$router.push({
      name: 'TenantDetails',
      params: {
        tenantId,
      },
    });
  }
}
